export default __webpack_public_path__ + "static/media/EnergyGuide_use1.daa4f329.png";